<template>
  <div v-if="products.length" class="product-carousel" @mouseenter="stopCarousel" @mouseleave="startCarousel" @touchstart="onTouchStart" @touchend="onTouchEnd" @touchcancel="onTouchEnd">
    <button type="button" class="carousel-arrow carousel-arrow--left" title="Previous product" aria-label="Previous product" @click="previous"><span aria-hidden="true"></span></button>
    <transition name="fade" mode="out-in">
      <ProductCard :key="currentProduct.id || index" :product="currentProduct" :image="currentImage" @select="openProduct" />
    </transition>
    <button type="button" class="carousel-arrow carousel-arrow--right" title="Next product" aria-label="Next product" @click="next"><span aria-hidden="true"></span></button>
    <div class="carousel-dots">
      <button v-for="(item, dotIndex) in currentDots" :key="dotKey(item, dotIndex)" type="button" :class="{ active: dotIndex === activeDotIndex }" :aria-label="dotLabel(dotIndex)" @click="goToDot(dotIndex)"></button>
    </div>
  </div>
</template>

<script>
import ProductCard from './ProductCard.vue'

export default {
  name: 'ProductCarousel',
  components: { ProductCard },
  props: { products: { type: Array, default: () => [] } },
  data () {
    return {
      index: 0,
      productTimer: null,
      touchStartX: 0,
      touchStartY: 0
    }
  },
  computed: {
    currentProduct () { return this.products[this.index] || {} },
    currentImage () { return this.currentProduct.homeImage || this.currentProduct.coverImage || '' },
    currentDots () { return this.products },
    activeDotIndex () { return this.index }
  },
  watch: {
    products () { this.setProductIndex(0) },
    index () {
      this.startCarousel()
    }
  },
  mounted () { this.startCarousel() },
  beforeDestroy () { this.stopCarousel() },
  methods: {
    next () { this.setProductIndex((this.index + 1) % this.products.length) },
    previous () { this.setProductIndex((this.index - 1 + this.products.length) % this.products.length) },
    setProductIndex (index) {
      this.index = index
      this.startCarousel()
    },
    nextProduct () {
      if (this.products.length < 2) return
      this.setProductIndex((this.index + 1) % this.products.length)
    },
    goToDot (dotIndex) {
      this.setProductIndex(dotIndex)
    },
    startCarousel () {
      this.stopCarousel()
      if (this.products.length > 1) {
        this.productTimer = window.setInterval(this.nextProduct, 5000)
      }
    },
    stopCarousel () {
      if (this.productTimer) window.clearInterval(this.productTimer)
      this.productTimer = null
    },
    dotKey (item, dotIndex) {
      return (item && item.id) || dotIndex
    },
    dotLabel (dotIndex) {
      return `Product ${dotIndex + 1}`
    },
    // Horizontal swipe support (mobile): swiping left shows the next product.
    onTouchStart (event) {
      const touch = event.changedTouches && event.changedTouches[0]
      if (!touch) return
      this.touchStartX = touch.clientX
      this.touchStartY = touch.clientY
      this.stopCarousel()
    },
    onTouchEnd (event) {
      const touch = event.changedTouches && event.changedTouches[0]
      if (!touch) return
      const dx = touch.clientX - this.touchStartX
      const dy = touch.clientY - this.touchStartY
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) this.next()
        else this.previous()
      }
      this.startCarousel()
    },
    openProduct (product) { this.$router.push(`/products/${product.id}`) }
  }
}
</script>
